
// Enhanced focus management for WCAG 2.2 AAA
function manageFocus(element, restorePrevious = false) {
  if (restorePrevious && window.lastFocusedElement) {
    window.lastFocusedElement.focus();
  } else if (element) {
    window.lastFocusedElement = document.activeElement;
    element.focus();
  }
}

// Enhanced keyboard shortcuts for AAA compliance
function handleKeyboardShortcuts(event) {
  // Ctrl+Enter to calculate
  if (event.ctrlKey && event.key === 'Enter') {
    event.preventDefault();
    const form = document.getElementById('deflection-form');
    if (form) {
      form.dispatchEvent(new Event('submit'));
    } else {
      runWithErrorHandling();
      manageFocus(document.deflection.Workspace);
    }
    return;
  }

  // Ctrl+R to reset (prevent browser refresh)
  if (event.ctrlKey && (event.key === 'r' || event.key === 'R')) {
    event.preventDefault();
    document.deflection.reset();
    document.querySelectorAll('[aria-invalid]').forEach(el => {
      el.removeAttribute('aria-invalid');
      el.removeAttribute('aria-describedby');
    });
    document.querySelectorAll('.error-message').forEach(el => el.remove());
    return;
  }

  // Escape to clear results
  if (event.key === 'Escape') {
    document.deflection.Workspace.value = '';
    return;
  }
}

// Real-time validation for AAA compliance
function validateInput(input, validationType) {
  const value = input.value.trim();
  let isValid = true;
  let errorMessage = '';

  // Check if input is empty
  if (value === '') {
    isValid = false;
    errorMessage = 'This field is required';
  }
  // Check if input is numeric
  else if (isNaN(value) || value === 'NaN') {
    isValid = false;
    errorMessage = 'Please enter a valid number';
  }
  // Validate range for numeric inputs
  else {
    const numValue = parseFloat(value);
    switch(validationType) {
      case 'diameter':
        isValid = numValue > 0 && numValue <= 1000;
        errorMessage = 'Diameter must be between 0.001 and 1000';
        break;
      case 'length':
        isValid = numValue > 0 && numValue <= 10000;
        errorMessage = 'Length must be between 0.001 and 10000';
        break;
      case 'force':
        isValid = numValue >= 0 && numValue <= 100;
        errorMessage = 'Force must be between 0 and 100';
        break;
      case 'wall':
        isValid = numValue >= 0;
        errorMessage = 'Wall thickness must be 0 or greater';
        break;
    }
  }

  // Update input validation state
  if (isValid) {
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
    // Remove error message if exists
    const errorId = input.id + '-error';
    const errorElement = document.getElementById(errorId);
    if (errorElement) {
      errorElement.remove();
    }
  } else {
    input.setAttribute('aria-invalid', 'true');
    const errorId = input.id + '-error';
    input.setAttribute('aria-describedby', errorId);

    // Create or update error message
    let errorElement = document.getElementById(errorId);
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.id = errorId;
      errorElement.className = 'error-message';
      errorElement.setAttribute('role', 'alert');
      input.parentNode.appendChild(errorElement);
    }
    errorElement.textContent = errorMessage;
  }

  return isValid;
}

// Sanitize input to prevent invalid characters
function sanitizeInput(input) {
  // Remove non-numeric characters except decimal point and minus sign
  const sanitized = input.value.replace(/[^0-9.-]/g, '');

  // Ensure only one decimal point
  const parts = sanitized.split('.');
  if (parts.length > 2) {
    input.value = parts[0] + '.' + parts.slice(1).join('');
  } else {
    input.value = sanitized;
  }

  // Remove leading zeros except for "0"
  if (input.value.length > 1 && input.value.startsWith('0') && !input.value.startsWith('0.')) {
    input.value = input.value.replace(/^0+/, '');
  }
}

// Enhanced calculation with robust error handling
function runWithErrorHandling() {
  // Validate all inputs first
  const inputs = [
    { element: document.deflection.Diain, type: 'diameter' },
    { element: document.deflection.Lenin, type: 'length' },
    { element: document.deflection.Forcelbs, type: 'force' },
    { element: document.deflection.Wallin, type: 'wall' }
  ];

  let allValid = true;
  let firstInvalidInput = null;

  inputs.forEach(input => {
    const isValid = validateInput(input.element, input.type);
    if (!isValid && !firstInvalidInput) {
      firstInvalidInput = input.element;
      allValid = false;
    }
  });

  if (!allValid) {
    // Focus first invalid input and provide guidance
    manageFocus(firstInvalidInput);
    const workspace = document.deflection.Workspace;
    workspace.value = 'Error: Please correct the highlighted input fields.\n\nTips:\n- Ensure all numeric fields have valid numbers\n- Diameter and length must be positive numbers\n- Wall thickness can be 0 for solid shafts\n- Remove any text or special characters';
    return;
  }

  // Additional validation to prevent NaN in calculations
  const diaValue = parseFloat(document.deflection.Diain.value);
  const lenValue = parseFloat(document.deflection.Lenin.value);
  const forceValue = parseFloat(document.deflection.Forcelbs.value);
  const wallValue = parseFloat(document.deflection.Wallin.value);

  if (isNaN(diaValue) || isNaN(lenValue) || isNaN(forceValue) || isNaN(wallValue)) {
    const workspace = document.deflection.Workspace;
    workspace.value = 'Calculation Error: Invalid numeric values detected.\n\nPlease check all input fields and ensure they contain valid numbers.';
    return;
  }

  // Run original calculation
  run();
}

function handleKeydown(event, value) {
  // Handle Enter and Space keys for keyboard accessibility
  if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
    event.preventDefault();
    setforce(value);
    // Return focus to force input after selection
    setTimeout(() => manageFocus(document.deflection.Forceg), 100);
  }
}

function round(num, exp)
{       n = Math.pow(10, exp);
        return Math.round(num*n) / n;
}

function run() {
    let fDia = parseFloat(document.deflection.Diain.value);
    let fLen = parseFloat(document.deflection.Lenin.value);
    let fMod = parseFloat(document.deflection.PSI.value);
    let fForce = parseFloat(document.deflection.Forcelbs.value);
    let fWall = parseFloat(document.deflection.Wallin.value) || 0;

    let fMnt;
    if (fWall === 0) {
        fMnt = (Math.pow(fDia, 4) * Math.PI) / 64; // Solid
    } else {
        const innerDia = fDia - (2 * fWall);
        fMnt = ((Math.pow(fDia, 4) - Math.pow(innerDia, 4)) * Math.PI) / 64; // Tube
    }

    const fDef = (fForce * Math.pow(fLen, 3)) / (3 * fMod * fMnt);

    document.deflection.Workspace.value = document.deflection.Workspace.value + "Deflection = " + round(convertin(fDef),4) + "mm, " + round(fDef,5) + " inches\n";
}

//------------------------------- Display Specfied  PSI for material
function setpsi()
{       document.deflection.PSI.value = document.deflection.Material.value ;
}
//--------------------- Convert from mmm to inchs
function convertmm(int)
{       return(int * .03937);
}
//--------------------- Convert from inchs to mm
function convertin(int)
{       return(round(int * 25.4,4));
}
//---------------------
function convertg(int,value)
{       return(int*value);
}

// Event Listeners Initialization
document.addEventListener('DOMContentLoaded', function() {
  // Add keyboard shortcuts listener
  document.addEventListener('keydown', handleKeyboardShortcuts);

  // Handle form submission for accessibility compliance
  const form = document.getElementById('deflection-form');
  if (form) {
    form.addEventListener('submit', function(event) {
      event.preventDefault(); // Prevent actual form submission
      runWithErrorHandling(); // Run our validation and calculation
      manageFocus(document.deflection.Workspace);
    });
  }

  // Set up listeners for synchronous dimension updates
  const inputs = {
      diamm: document.getElementById('Diamm'),
      diain: document.getElementById('Diain'),
      wallmm: document.getElementById('Wallmm'),
      wallin: document.getElementById('Wallin'),
      lenmm: document.getElementById('Lenmm'),
      lenin: document.getElementById('Lenin'),
      forceg: document.getElementById('Forceg'),
      forceUnit: document.getElementById('ForceUnit1'),
      forcelbs: document.getElementById('Forcelbs'),
      material: document.getElementById('Material'),
      psi: document.getElementById('PSI')
  };

  if (inputs.diamm) {
      inputs.diamm.addEventListener('input', function() {
          const val = parseFloat(this.value);
          if(!isNaN(val)) inputs.diain.value = round(convertmm(val), 4);
      });
  }
  if (inputs.diain) {
      inputs.diain.addEventListener('input', function() {
          const val = parseFloat(this.value);
          if(!isNaN(val)) inputs.diamm.value = round(convertin(val), 2);
      });
  }

  if (inputs.wallmm) {
      inputs.wallmm.addEventListener('input', function() {
          const val = parseFloat(this.value);
          if(!isNaN(val)) inputs.wallin.value = round(convertmm(val), 4);
      });
  }
  if (inputs.wallin) {
      inputs.wallin.addEventListener('input', function() {
          const val = parseFloat(this.value);
          if(!isNaN(val)) inputs.wallmm.value = round(convertin(val), 2);
      });
  }

  if (inputs.lenmm) {
      inputs.lenmm.addEventListener('input', function() {
          const val = parseFloat(this.value);
          if(!isNaN(val)) inputs.lenin.value = round(convertmm(val), 4);
      });
  }
  if (inputs.lenin) {
      inputs.lenin.addEventListener('input', function() {
          const val = parseFloat(this.value);
          if(!isNaN(val)) inputs.lenmm.value = round(convertin(val), 2);
      });
  }

  function updateForce() {
      if (inputs.forceg && inputs.forceUnit && inputs.forcelbs) {
          const fg = parseFloat(inputs.forceg.value);
          const fu = parseFloat(inputs.forceUnit.value);
          if(!isNaN(fg) && !isNaN(fu)) {
              inputs.forcelbs.value = convertg(fg, fu);
          }
      }
  }

  if (inputs.forceg) inputs.forceg.addEventListener('input', updateForce);
  if (inputs.forceUnit) inputs.forceUnit.addEventListener('change', updateForce);

  if (inputs.material) {
      inputs.material.addEventListener('change', function() {
          inputs.psi.value = this.value;
      });
  }

  // Clear button
  const clearBtn = document.querySelector('input[name="Clear"]');
  if (clearBtn) {
      clearBtn.addEventListener('click', function() {
          document.deflection.Workspace.value = '';
      });
  }

  // Add real-time validation to inputs
  const allTextInputs = document.querySelectorAll('input[type="text"]');
  allTextInputs.forEach(input => {
    input.addEventListener('input', function() {
      sanitizeInput(input);
      let validationType = '';
      if (input.id.includes('Dia')) validationType = 'diameter';
      else if (input.id.includes('Len')) validationType = 'length';
      else if (input.id.includes('Force')) validationType = 'force';
      else if (input.id.includes('Wall')) validationType = 'wall';
      if (validationType) validateInput(input, validationType);
    });
    input.addEventListener('blur', function() {
      let validationType = '';
      if (input.id.includes('Dia')) validationType = 'diameter';
      else if (input.id.includes('Len')) validationType = 'length';
      else if (input.id.includes('Force')) validationType = 'force';
      else if (input.id.includes('Wall')) validationType = 'wall';
      if (validationType) validateInput(input, validationType);
    });
  });

  // Add focus management for form buttons
  const resetBtn = document.querySelector('input[name="B2"]');
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      document.querySelectorAll('[aria-invalid]').forEach(el => {
        el.removeAttribute('aria-invalid');
        el.removeAttribute('aria-describedby');
      });
      document.querySelectorAll('.error-message').forEach(el => el.remove());
    });
  }
});

function setforce(var1) {
  if (isNaN(var1) || var1 === 'NaN') {
    const workspace = document.deflection.Workspace;
    workspace.value = 'Error: Invalid force value selected. Please try again.';
    return;
  }

  document.deflection.Forceg.value = var1;
  document.deflection.ForceUnit1.options[1].selected = true;
  document.deflection.Forcelbs.value = convertg(document.deflection.Forceg.value, document.deflection.ForceUnit1.value);

  validateInput(document.deflection.Forceg, 'force');
  validateInput(document.deflection.Forcelbs, 'force');

  const workspace = document.deflection.Workspace;
  const currentValue = workspace.value;
  const feedback = `Force set to ${var1} Newtons`;

  if (currentValue.trim() === '') {
    workspace.value = feedback;
  } else {
    workspace.value = currentValue + '\n' + feedback;
  }

  const announcement = document.createElement('div');
  announcement.setAttribute('role', 'status');
  announcement.setAttribute('aria-live', 'polite');
  announcement.className = 'sr-only';
  announcement.textContent = feedback;
  document.body.appendChild(announcement);
  setTimeout(() => document.body.removeChild(announcement), 1000);
}
